<template>
  <div id="app">
    <div class="overlay">
<!-- Add div above NAvBAr - Free Estimates - 50 YEar Warranty  -->
      <NavBar />
      <main id="main-content">
        <router-view></router-view>
      </main>
    </div>
  </div>

</template>

<script>
import NavBar from './components/NavBar.vue';
export default {
  name: 'App',
  components: {
    NavBar
}
}

</script>

<style>
#app {
  position: relative;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100vh;
}
.overlay {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

body {
  margin: 0;
}

#main-content {
  display: block;
}
*, *:before, *:after {
    box-sizing: border-box;
}

/* Phones: the floating quote button becomes a full-width bar at the bottom of the
   screen, and the footer gets room underneath so the bar never covers it. */
@media (max-width: 600px) {
  #app .floatingContact .contact-button {
    left: 12px;
    right: 12px;
    bottom: max(12px, env(safe-area-inset-bottom));
    width: auto;
    min-width: 0;
    max-width: none;
    height: 52px;
    border-radius: 12px;
    font-size: 1rem;
    animation: none;
  }
  #app:has(.floatingContact) .footer {
    padding-bottom: 84px;
  }
}



</style>
